import { toast } from 'sonner';
import { menuApi } from '@verlo/shared/services/api';
import { sizesForSave } from '../../lib/choicePrices';

// A dish's editor saves the same way wherever it's opened: Items, or Structure, where it now
// opens in place so Save and Cancel leave you where you were (Back office sweep, Oct 2026).
export async function saveMenuItem(form, site) {
  const price = parseFloat(form.price) || 0;
  // A size with its price cleared is the item's price: `parseFloat('') || 0` sold it for nothing.
  const sizes = sizesForSave(form.size_options, price);
  const payload = {
    ...form,
    price,
    cost: parseFloat(form.cost) || 0,
    // From the sizes that are actually saved: a nameless row left `has_sizes` true with no
    // sizes, which marks every line of that item price-unverified.
    has_sizes: sizes.length > 0,
    size_options: sizes,
  };
  if (form.id) {
    await menuApi.update(form.id, payload);
    toast.success(`${form.name} saved`);
  } else {
    await menuApi.create(payload, site);
    toast.success(`${form.name} added`);
  }
}
